import { render, staticRenderFns } from "./Edit.vue?vue&type=template&id=49e885c4&scoped=true&"
import script from "./Edit.vue?vue&type=script&lang=js&"
export * from "./Edit.vue?vue&type=script&lang=js&"
import style0 from "./Edit.vue?vue&type=style&index=0&id=49e885c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49e885c4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49e885c4')) {
      api.createRecord('49e885c4', component.options)
    } else {
      api.reload('49e885c4', component.options)
    }
    module.hot.accept("./Edit.vue?vue&type=template&id=49e885c4&scoped=true&", function () {
      api.rerender('49e885c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/budget-control/instance/Edit.vue"
export default component.exports